import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import CellContainer from "../CellContainer.js";
import { Label } from "../Styles.js";
import { named } from "../../../utils/named.js";
const getLabel = (value) => {
  if (value === void 0 || value === null) {
    return "";
  }
  return `${value}`;
};
const Renderer = (props) => {
  var _a, _b, _c, _d, _e, _f;
  const { cell, isDiffView } = props;
  const label = getLabel(cell == null ? void 0 : cell.value);
  const diffLabel = getLabel(cell == null ? void 0 : cell.diffValue);
  const showDiff = !(cell == null ? void 0 : cell.active) && (!!(cell == null ? void 0 : cell.diffValue) || isDiffView) && label !== diffLabel;
  const unresolvedDecision = ((_a = cell == null ? void 0 : cell.metadata) == null ? void 0 : _a.requiresDecision) && !((_b = cell == null ? void 0 : cell.metadata) == null ? void 0 : _b.acceptedValue);
  const acceptedValue = (_c = cell == null ? void 0 : cell.metadata) == null ? void 0 : _c.acceptedValue;
  const isDecisioning = (_d = cell == null ? void 0 : cell.metadata) == null ? void 0 : _d.isDecisioning;
  return /* @__PURE__ */ jsx(CellContainer, { ...props, children: showDiff ? /* @__PURE__ */ jsxs(Fragment, { children: [
    label && /* @__PURE__ */ jsxs(Fragment, { children: [
      unresolvedDecision && isDecisioning && /* @__PURE__ */ jsx(Label, { requiresDecision: true, title: label, children: label }),
      (!unresolvedDecision || !isDecisioning) && /* @__PURE__ */ jsx(Fragment, { children: acceptedValue === "source" ? /* @__PURE__ */ jsx(Label, { added: true, title: label, children: label }) : /* @__PURE__ */ jsx(Label, { removed: true, title: label, children: label }) })
    ] }),
    diffLabel && /* @__PURE__ */ jsxs(Fragment, { children: [
      !unresolvedDecision && /* @__PURE__ */ jsx(
        Label,
        {
          ...acceptedValue === "source" || ((_e = cell == null ? void 0 : cell.config) == null ? void 0 : _e.markedForDeletion) ? { removed: true } : { added: true },
          title: diffLabel,
          children: diffLabel
        }
      ),
      unresolvedDecision && /* @__PURE__ */ jsx(Label, { requiresDecision: true, title: diffLabel, children: diffLabel })
    ] })
  ] }) : /* @__PURE__ */ jsx(
    Label,
    {
      mutated: props.mutated,
      removed: (_f = cell == null ? void 0 : cell.config) == null ? void 0 : _f.markedForDeletion,
      title: label.length > 37 ? label : void 0,
      children: label
    }
  ) });
};
named("DefaultRenderer", Renderer);
export {
  Renderer as default
};
